const moduleLabels = { dashboard: '概览', stores: '团队管理', users: '账号管理', roles: '角色与权限', permissions: '权限目录', uploads: '文件上传', content: '内容管理', media: '媒体管理', auth: '账号安全' };

function errorMessage(error, fallback = '操作失败，请稍后重试') {
  return error && error.response && error.response.data && error.response.data.message || error && error.userMessage || fallback;
}
function safeLogo(value) {
  if (typeof value !== 'string') return '';
  return /^\/(?!\/)/.test(value) || /^https?:\/\//i.test(value) ? value : '';
}
function passwordError(value, optional) {
  if (!value && optional) return '';
  const length = new TextEncoder().encode(value || '').length;
  return length >= 8 && length <= 72 ? '' : '密码需为 8–72 字节（中文字符占多个字节）';
}
function editableUser(user, actor) {
  return !Number(user.is_super_admin) && !Number(user.is_store_admin) && String(user.id) !== String(actor.id);
}
function editableRole(role, actor) {
  return !(actor.roles || []).some((assigned) => String(assigned.id) === String(role.id));
}
function userPayload(form, platform, editing) {
  const data = { username: (form.username || '').trim(), display_name: (form.display_name || '').trim(), status: Number(form.status), role_ids: Array.from(new Set((form.role_ids || []).map(Number).filter((id) => Number.isInteger(id) && id > 0))) };
  if (!editing || form.password) data.password = form.password || '';
  if (platform && !editing) data.store_id = Number(form.store_id);
  return data;
}
function rolePayload(form, selected, leaves, platform, editing) {
  const validCodes = new Set(leaves.map((leaf) => leaf.code));
  const data = { name: (form.name || '').trim(), code: (form.code || '').trim(), description: (form.description || '').trim(), permissions: Array.from(new Set(selected.filter((code) => validCodes.has(code)))) };
  if (platform && !editing) data.store_id = Number(form.store_id);
  return data;
}
function storePayload(form, editing) {
  if (!editing) return { name: form.name.trim(), username: form.admin_username.trim(), password: form.admin_password, display_name: form.admin_display_name.trim() };
  const data = { name: form.name.trim(), logo: form.logo || '', status: Number(form.status), admin_username: form.admin_username.trim(), admin_display_name: form.admin_display_name.trim() };
  if (form.admin_password) data.admin_password = form.admin_password;
  return data;
}
function storeStatusPayload(enabled) {
  return { status: enabled ? 1 : 0 };
}
async function createStoreWithLogo(api, payload, file) {
  const created = await api.createStore(payload);
  if (!file) return created;
  let uploadedLogo = '';
  try {
    const upload = await api.uploadLogo(created.id, file);
    uploadedLogo = upload.url;
    return await api.updateStore(created.id, { logo: uploadedLogo });
  } catch (error) {
    // A persisted store must become an edit retry, never another create request.
    error.createdStore = created;
    error.uploadedLogo = uploadedLogo;
    throw error;
  }
}
function permissionGroups(leaves, actorCodes, unrestricted) {
  const allowed = new Set(actorCodes || []);
  const groups = new Map();
  leaves.filter((leaf) => !Number(leaf.is_platform)).forEach((leaf) => {
    const module = leaf.module || 'other';
    if (!groups.has(module)) groups.set(module, { code: `module:${module}`, label: moduleLabels[module] || module, disabled: true, children: [] });
    groups.get(module).children.push({ ...leaf, label: leaf.name, disabled: !unrestricted && !allowed.has(leaf.code) });
  });
  return Array.from(groups.values());
}
module.exports = { userPayload, rolePayload, storePayload, storeStatusPayload, permissionGroups, editableUser, editableRole, safeLogo, errorMessage, passwordError, createStoreWithLogo };
